module.exports = {
    "message.lzdInboundCreateView.tableColumn.sellerCountry": "国家",
    "message.inboundView.title.warehouseList": "仓库列表",
    "message.table.fulfillment.receiverZip": "收件人邮编",
    "message.views.stockAllocation.channelLock": "锁住渠道",
    "message.lzdOutboundViewDetail.title.basicInformation": "基本信息",
    "message.lzdInboundPlanView.replenishColumns.operate": "操作",
    "message.views.workbench.shopGmvProportion": "店铺Gmv占比",
    "message.lzdInboundPlanView.replenishColumns.gmtCreate": "创建时间",
    "message.views.workbench.dailyOrderQuantity": "日订单量",
    "message.login.switch_to_zh_cn": "切换为中文",
    "message.aegInboundDetail.title.warehouseAddress": "仓库地址",
    "message.views.activityInventory.site": "站点",
    "message.card.fulfillment.buyerName": "买家名称",
    "message.table.fulfillment.orderItemStatus": "子单状态",
    "message.lzdInboundDetail.title.sellerName": "小二名称",
    "message.lzdInboundCreateView.tableColumn.deleteBtn": "删除",
    "message.CreateTransferOrder.destPlatform": "目的行业",
    "message.views.workbench.dashboardDescription.channelProductSold": "最近一周不同渠道品销量柱形图",
    "message.CreateTransferOrder.skuView.reset": "重置",
    "message.views.scItemView.shelfLifeManagement": "保质期管理",
    "message.transform.isSuccess": "是否成功",
    "message.views.inventoryReconciliation.changeTypeMap.totalFound": "盘盈",
    "message.views.workbench.merchantCode": "行业",
    "message.lzdInboundDetail.title.orderStatus": "订单状态",
    "message.views.activityInventory.search": "搜索",
    "message.transform.stockBindStore": "库存绑定店铺",
    "message.transform.firstStep": "第一步",
    "message.CreateTransferOrder.operate": "操作",
    "message.views.feedback.feedbackOptions.systemBug": "系统缺陷",
    "message.button.orderExport": "导出订单",
    "message.aegInboundDetail.goodsTable.title": "货品名称",
    "message.menu.taskCenterItem": "下载中心",
    "message.table.fulfillment.actualPaidFee": "实际付款价格",
    "message.views.workbench.totalGmv": "总销售额",
    "message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr": "入库上架时间",
    "message.aegOutboundOrderDetail.title.remark": "备注",
    "message.card.fulfillment.receiverProvince": "收件人省",
    "message.TransferOrder.toMerchant": "调入行业",
    "message.views.dashboardScore.dashboardName.all_authorized_shop": "已授权店铺",
    "message.outboundView.button.exportSelectedOrder": "选择导出",
    "message.lzdInboundDetail.title.purchaseOrderCode": "采购单号",
    "message.aegOutboundOrderDetail.purchaseItemColumn.remark": "备注",
    "message.outboundView.button.importBtn": "导入",
    "message.lzdInboundDetail.title.warehouseAddress": "仓库地址",
    "message.aegInboundDetail.title.storeCode": "仓库编码",
    "message.transform.shopBinding": "店铺绑定中",
    "message.aegInboundDetail.logisticColumns.bizOrderNo": "流水单号",
    "message.views.productView.brand": "品牌",
    "message.lzdInboundDetail.title.basicInformation": "基本信息",
    "message.button.save": "保存",
    "message.views.inventoryLedger.orderTypeMap.IMBALANCE_LOCK": "仓库锁定",
    "message.views.workbench.dashboardDescription.totalOrderQuantity": "总订单量：所有仓发订单量总和，周同比：（本周订单量-去年本周订单量）/去年本周订单量 ，日同比 （今日订单量-去年今日订单量）/去年今日订单量 日订单量：今日订单总和",
    "message.views.inventoryAging.91-120day": "91-120 天",
    "message.lzdInboundCreateView.tableColumn.contactInfo": "联系人",
    "message.aegInboundDetail.title.expiredTime": "失效时间",
    "message.table.fulfillment.sellerName": "卖家名称",
    "message.outboundView.table.warehouse": "仓库",
    "message.menu.publishTemplateView": "发品模板",
    "message.views.liveInventory.warehouseCode": "仓编码",
    "message.views.scItemView.manufacturePackageDimensions": "包裹尺寸",
    "message.CreateTransferOrder.senderName": "发货人",
    "message.taskCenterView.table.creator": "发起人",
    "message.lzdOutboundViewDetail.title.estimateTimeStr": "预计到达时间",
    "message.views.liveInventory.sellable": "可售",
    "message.menu.stockAllocation": "渠道库存管理",
    "message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime": "预约时间",
    "message.transform.shopBindFailed": "店铺绑定失败",
    "message.CreateTransferOrder.sellerSKU": "源商品",
    "message.views.productPublishView.plsSelectTheCategory": "请选择类目",
    "message.table.fulfillment.cbOrderStatusDesc": "跨境订单状态",
    "message.views.publishTemplateView.submit": "提交",
    "message.table.fulfillment.orderStatus": "订单状态码",
    "message.card.fulfillment.warehouseName": "仓名称",
    "message.views.workbench.dod": "日同比",
    "message.menu.createNewInboundOrder": "创建入库单",
    "message.login.log_out": "退出登录",
    "message.CreateTransferOrder.senderCountry": "发货国家",
    "message.views.workbench.totalOrderQuantity": "总订单量",
    "message.views.liveInventory.code": "编号",
    "message.button.printPdf": "打印pdf",
    "message.outboundView.table.platform": "行业",
    "message.table.fulfillment.tradeCreateTime": "订单创建时间",
    "message.views.inventoryLedger.operateTime": "操作时间",
    "message.menu.createNewOutboundOrder": "创建出库单",
    "message.table.fulfillment.siteId": "站点",
    "message.TransferOrder.operate": "操作",
    "message.inboundView.table.merchantCode": "商家编码",
    "message.CreateTransferOrder.platform": "源行业",
    "message.taskCenterView.table.downLoad": "下载",
    "message.views.stockAllocation.adjustRuleFailed": "调整渠道比例失败",
    "message.views.productView.category": "类目",
    "message.inboundView.table.orderStatus": "订单状态",
    "message.inboundView.table.orderQuantity": "下单数量",
    "message.TransferOrder.platform": "行业",
    "message.transform.startShopBindCheck": "开始店铺绑定检查",
    "message.views.productPublishView.plsChooseTemplateToPublish": "选择模板辅助发品",
    "message.outboundView.title.returnReason": "退供原因",
    "message.views.stockAllocation.cancel": "取消",
    "message.outboundView.table.merchantCode": "商家编码",
    "message.transform.itemCheck": "Platform Sku/Fulfillment Sku 检查",
    "message.transform.errorFile": "错误文件",
    "message.views.workbench.thisQuarter": "本季",
    "message.views.workbench.today": "今天",
    "message.views.scItemView.mainShop": "主店铺",
    "message.views.productView.scItemMerchant": "货品市场",
    "message.table.fulfillment.buyerId": "买家id",
    "message.menu.feedback.dashboardScore": "报表评分",
    "message.aegOutboundOrderDetail.purchaseItemColumn.barcode": "条形码",
    "message.views.workbench.productSoldRank": "品销量排行",
    "message.views.productPublishView.inputSearchText": "请输入",
    "message.views.scItemView.serialNumberManagement": "序列号管理",
    "message.views.dashboardScore.dashboardName.inventory_turn_over": "库存周转率报表",
    "message.transform.shopBindFailedAndDownload": "店铺绑定失败，下载失败详情",
    "message.table.fulfillment.itemTaxActualFee": "实际税费",
    "message.views.inventoryLedger.orderTypeMap.TRADE_OUT": "履约出库",
    "message.aegInboundDetail.title.cancelReason": "取消原因",
    "message.views.workbench.orderQuantityRank": "订单量排行",
    "message.views.activityInventory.fulfillmentSkuName": "货品名称",
    "message.transform.success": "成功",
    "message.views.scItemView.width": "宽度",
    "message.aegOutboundOrderDetail.title.inventoryType": "库存类型",
    "message.card.fulfillment.receiverName": "收件人姓名",
    "message.table.fulfillment.receiverAddress": "收件人地址",
    "message.views.stockAllocation.adjustStockFailed": "调整库存失败",
    "message.transform.inventoryCheck": "库存检查",
    "message.aegOutboundOrderDetail.title.logisticLogs": "物流执行日志",
    "message.menu.scItemView": "货品",
    "message.views.inventoryLedger.orderTypeMap.OUTBOUND": "商家出库",
    "message.menu.cbFulfillmentOrder": "跨境订单",
    "message.views.productView.skuStock": "SKU 库存",
    "message.views.workbench.authorizationShop": "已授权店铺",
    "message.table.fulfillment.itemActualPaidFee": "实际付款价格",
    "message.views.workbench.activityResult": "运营效果",
    "message.views.publishTemplateView.shortDesc": "短描述",
    "message.common.fulfillment.ship": "发货",
    "message.views.stockAllocation.submit": "提交",
    "message.views.workbench.allShop": "全部店铺",
    "message.aegInboundDetail.goodsTable.normalQtyDec": "实收正品数量",
    "message.taskCenterView.title.createdTime": "提交时间",
    "message.transform.finished": "完成",
    "message.TransferOrder.requested": "请求数量",
    "message.table.fulfillment.cbOrderStatus": "跨境订单状态码",
    "message.lzdInboundDetail.lzdItemTable.itemRequested": "计划入库数量",
    "message.views.liveInventory.onWay.transferOnWay": "调拨在途",
    "message.views.productPublishView.plsSelectThePublishShop": "请选择目标发布店铺",
    "message.views.productView.gmtModified": "修改时间",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherOutbounded": "其他出库",
    "message.views.liveInventory.cargo": "货品",
    "message.views.workbench.warehouse": "仓库",
    "message.table.fulfillment.totalFee": "总价",
    "message.transform.ae.description": "AE店铺绑定入口",
    "message.table.fulfillment.skuId": "Sku Id",
    "message.views.inventoryLedger.orderType": "单据类型",
    "message.views.workbench.yoy": "同比",
    "message.taskCenterView.table.operate": "操作",
    "message.lzdInboundCreateView.title.sellerAddress": "商家地址",
    "message.transform.selectStoresToBindInventory": "选择要绑定库存的店铺",
    "message.views.productPublishView.clickDownloadPublishTemplate": "下载发品模板",
    "message.lzdInboundDetail.lzdItemTable.goodsBarcode": "箱码",
    "message.lzdOutboundViewDetail.title.orderStatusName": "单据状态",
    "message.lzdInboundDetail.lzdItemTable.scItemCode": "货品编码",
    "message.transform.upStep": "上一步",
    "message.views.liveInventory.onWay.inBoundOnWay": "入库在途",
    "message.views.productPublishView.publishShop": "目标发布店铺",
    "message.card.fulfillment.receiverMobile": "收件人手机",
    "message.aegInboundDetail.logisticColumns.operator": "操作人",
    "message.views.inventoryAging.greate180day": "大于180天",
    "message.lzdInboundDetail.title.sellerInformation": "小二信息",
    "message.views.feedback.feedbackContent": "反馈内容",
    "message.CreateTransferOrder.estimatedOutboundTime": "预计出库时间",
    "message.menu.productPublishView": "商品发布",
    "message.views.feedback.feedbackOptions.questionFeedback": "问题反馈",
    "message.form.fulfillment.cbFulfillmentOrderId": "跨境履约单号",
    "message.views.inventoryReconciliation.changeTypeMap.totalLost": "盘亏",
    "message.views.productView.platformTitle": "商品名称",
    "message.TransferOrder.exportBtn": "导出",
    "message.form.fulfillment.warehouseCode": "仓库编码",
    "message.views.scItemView.barcode": "货品条码",
    "message.taskCenterView.table.taskStatus": "任务状态",
    "message.views.stockAllocation.totalInventory": "总库存",
    "message.drawer.fulfillment.shippingName": "配送公司",
    "message.lzdOutboundViewDetail.title.warehouseName": "入仓名称",
    "message.views.dashboardScore.dashboardName.monthly_product_sold_and_item_ranking": "一年内月度品销量订单量及爆品排行报表",
    "message.aegInboundDetail.logisticColumn.fulfillStatus": "变更状态",
    "message.views.inventoryLedger.resultQuantity": "结果数量",
    "message.views.inventoryLedger.orderTypeMap.OTHER": "其他",
    "message.views.feedback.feedbackType": "问题类型",
    "message.lzdInboundCreateView.addSkuView.operate": "操作",
    "message.TransferOrder.inboundOrderNO": "入库单号",
    "message.lzdInboundDetail.title.skus": "货品明细",
    "message.aegInboundDetail.purchaseItemColumn.quantityDec": "采购数量",
    "message.views.scItemView.sellerSku": "Seller Sku",
    "message.inboundView.button.createOutboundBtn": "创建",
    "message.views.productPublishView.submit": "提交",
    "message.drawer.fulfillment.trackingNumbers": "运单号",
    "message.select.fulfillment.deliveryFailed": "配送失败",
    "message.card.fulfillment.shipperId": "货主id",
    "message.card.fulfillment.orderInformation": "订单信息",
    "message.views.productView.skuStatus": "SKU 状态",
    "message.views.workbench.currentQuantity": "当前数量",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_OUT": "库存调整出库",
    "message.lzdInboundCreateView.title.sellerFlag": "商家信息",
    "message.lzdOutboundViewDetail.title.mobile": "联系方式",
    "message.views.scItemView.temperatureCondition": "温度要求",
    "message.table.fulfillment.receiverCity": "收件人市",
    "message.message.fulfillment.chooseOneOrder": "至少选择一个单子进行发货",
    "message.lzdOutboundViewDetail.title.sellerName": "小二名称",
    "message.table.fulfillment.cbFulfillmentOrderItemId": "跨境子履约单号",
    "message.lzdInboundDetail.title.sellerAddress": "小二地址",
    "message.lzdInboundDetail.lzdItemTable.scItemName": "商家SKU名称",
    "message.card.fulfillment.tradeOrderItemId": "子订单号",
    "message.aegInboundDetail.goodsTable.quantityDec": "采购数量",
    "message.login.switch_to_en_us": "Switch To English",
    "message.inboundView.button.exportBtn": "导出",
    "message.views.scItemView.itemSite": "商品站点",
    "message.views.liveInventory.shipper": "货主",
    "message.views.stockAllocation.ratio": "比例",
    "message.transform.startTime": "开始时间",
    "message.views.workbench.dailyGmv": "日销售额",
    "message.views.dashboardScore.dashboardName.all_product_sold": "总品销量",
    "message.lzdInboundCreateView.addSkuView.queryView.platformSku": "平台Sku",
    "message.select.fulfillment.completeShipping": "全部发货",
    "message.views.workbench.totalProductSold": "总品销量",
    "message.CreateTransferOrder.fulfillmentSKU": "源货品",
    "message.CreateTransferOrder.transferQuantity": "计划调拨数量",
    "message.views.productPublishView.brand": "品牌",
    "message.TransferOrder.transfered": "已入库数",
    "message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo": "出库单号",
    "message.menu.activityInventory": "活动库存",
    "message.views.scItemView.downShelf": "下架",
    "message.views.workbench.inboundOrderNo": "入库单号",
    "message.aegInboundDetail.title.cancelTime": "取消时间",
    "message.views.inventoryAging.fulfillmentSkuCode": "货品Code",
    "message.views.inventoryReconciliation.changeTypeMap.totalSellerInboundedStock": "卖家入库",
    "message.aegOutboundOrderDetail.title.merchantName": "商家名称",
    "message.views.liveInventory.occupy": "占用",
    "message.form.fulfillment.plName": "配送商",
    "message.CreateTransferOrder.destSellerSKU": "目的商品",
    "message.inboundView.button.importBtn": "导入",
    "message.outboundView.button.AegTemplate": "Aeg模板",
    "message.views.workbench.toDeliver": "去发货",
    "message.TransferOrder.inboundWarehouse": "入库仓库",
    "message.views.scItemView.category": "类目",
    "message.views.workbench.dashboardDescription.totalProductSoldQuantity": "总品销量:所有仓发订单商品数量总和，图标内容：最近七天品销量数据，日品销量：今日所有仓发订单商品数量总和",
    "message.lzdInboundDetail.title.deliverType": "配送类型",
    "message.lzdInboundCreateView.tableColumn.addBtn": "添加",
    "message.lzdInboundCreateView.tableColumn.sellerCity": "城市",
    "message.views.inventoryReconciliation.changeTypeMap.totalReturnToSeller": "卖家出库",
    "message.form.fulfillment.fulfillmentOrderId": "履约单号",
    "message.lzdInboundCreateView.tableColumn.sellerPostcode": "邮政编码",
    "message.menu.createTransferOrder": "创建调拨单",
    "message.lzdInboundCreateView.addSkuView.serialNumber": "序号",
    "message.lzdInboundDetail.title.warehouseName": "仓库",
    "message.inboundView.title.platform": "行业列表",
    "message.lzdInboundPlanView.queryForm.replenishment": "补货入库",
    "message.transform.shopBind": "店铺绑定",
    "message.views.productPublishView.templateDetail": "模板详情",
    "message.card.fulfillment.promiseEarliestDate": "承诺最早日期",
    "message.views.activityInventory.expireTime": "结束时间",
    "message.views.workbench.dailyProductSold": "日品销量",
    "message.menu.inboundPlanItem": "补货",
    "message.inboundView.alert.sure": "确认",
    "message.lzdInboundPlanView.replenishColumns.scItemName": "货品",
    "message.lzdInboundPlanView.queryForm.shopName": "店铺",
    "message.views.liveInventory.commodity": "商品",
    "message.message.fulfillment.shippingSuccess": "发货成功",
    "message.views.scItemView.platformSkuDetail": "商品详情",
    "message.TransferOrder.transferOrderNo": "调拨单号",
    "message.lzdInboundCreateView.tableColumn.sellerDetail": "详细地址",
    "message.views.productView.itemSite": "站点",
    "message.views.productView.fulfillmentTitle": "货品名称",
    "message.inboundView.table.createTime": "创建时间",
    "message.transform.check": "库存绑定检查",
    "message.views.productPublishView.pleaseChooseTheShop": "请选择店铺",
    "message.transform.isDone": "是否完成",
    "message.views.productView.operation": "操作",
    "message.login.language": "语言",
    "message.aegInboundDetail.purchaseItemColumn.receivedNormalQty": "实收正品数量",
    "message.CreateTransferOrder.addSkuBtn": "添加",
    "message.views.feedback.systemRate": "系统评分",
    "message.taskCenterView.title.taskStatus": "任务状态",
    "message.views.activityInventory.platformSkuName": "商品名称",
    "message.lzdInboundCreateView.addSkuView.goodQuantity": "正品数量",
    "message.lzdInboundDetail.lzdItemTable.orderItemStatus": "SKU状态",
    "message.views.productView.searchButton": "搜索",
    "message.lzdInboundCreateView.addSkuView.platformSku": "平台Sku",
    "message.views.liveInventory.warehouseName": "仓名称",
    "message.aegInboundDetail.btn.detail": "详情",
    "message.table.fulfillment.actualItemPaidFee": "子单实付价",
    "message.menu.liveInventory": "实时库存",
    "message.CreateTransferOrder.senderTel": "发货人电话",
    "message.button.cancel": "取消",
    "message.views.liveInventory.onWayName": "在途",
    "message.transform.failed": "失败",
    "message.views.scItemView.fulfillmentSkuDetail": "货品详情",
    "message.views.productPublishView.pleaseSelectTheCategory": "请选择类目",
    "message.lzdInboundPlanView.replenishColumns.destinationCode": "目的仓库",
    "message.views.liveInventory.unSellable": "不可售",
    "message.views.inventoryLedger.inventoryType": "库存类型",
    "message.views.workbench.ito": "库存周转率",
    "message.views.scItemView.deleteRelatedPlatformSku": "商品解绑",
    "message.views.publishTemplateView.search": "搜索",
    "message.menu.workbench": "工作台",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_IN": "调整入库",
    "message.card.fulfillment.fulfillmentOrderItemId": "子履约单号",
    "message.lzdInboundDetail.title.inboundOrderCode": "入库单号",
    "message.select.fulfillment.deliverySuccess": "配送成功",
    "message.views.dashboardScore.dashboardName.to_inbound": "待入库",
    "message.lzdInboundPlanView.replenishColumns.replQuantity": "建议补货数量",
    "message.views.productPublishView.category": "类目",
    "message.CreateTransferOrder.senderPostCode": "发货人邮编",
    "message.inboundView.table.detail": "详情",
    "message.views.scItemView.upShelf": "上架",
    "message.views.workbench.channelOrderQuantity": "渠道单量",
    "message.views.scItemView.addRelatedPlatformSku": "商品绑定",
    "message.outboundView.title.platform": "行业列表",
    "message.views.stockAllocation.adjustRuleSuccess": "调整渠道比例成功",
    "message.menu.fulfillment": "履约",
    "message.views.liveInventory.name": "名称",
    "message.views.scItemView.sureDelete": "确认删除?",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc": "变更描述",
    "message.TransferOrder.status": "订单状态",
    "message.aegInboundDetail.title.purchaseOrderCode": "采购单号",
    "message.aegOutboundOrderDetail.title.totalReturnQuantity": "实退数量",
    "message.aegInboundDetail.purchaseItemColumn.sentQty": "商家发货数量",
    "message.CreateTransferOrder.skuView.platformSku": "Platform SKU",
    "message.transform.shopList": "绑定店铺列表",
    "message.inboundView.table.skuQuantity": "sku数量",
    "message.transform.bindSuccess": "库存绑定成功",
    "message.views.scItemView.height": "高度",
    "message.aegOutboundOrderDetail.logisticColumns.bizOrderNo": "变更单号",
    "message.views.scItemView.weight": "重量",
    "message.views.activityInventory.campaignName": "活动名称",
    "message.views.workbench.totalItemSold": "总品销量",
    "message.views.scItemView.gmtModified": "修改时间",
    "message.transform.auth": "授权",
    "message.aegOutboundOrderDetail.consignColumn.supplierName": "商家名称",
    "message.outboundView.title.orderStatus": "订单状态",
    "message.views.workbench.channelSales": "渠道销售额",
    "message.views.scItemView.searchButton": "搜索",
    "message.common.commit": "提交",
    "message.transform.shipperCheck": "货主检查",
    "message.modal.pdfContext": "前往打印/下载",
    "message.views.workbench.deliver": "发货",
    "message.table.fulfillment.fulfillmentOrderItemId": "子履约单号",
    "message.views.inventoryLedger.orderTypeMap.B2B_PURCHASE_IN": "投递失败入库",
    "message.drawer.fulfillment.deliverySuccess": "配送成功",
    "message.lzdInboundCreateView.tableColumn.estimatedTime": "预计时间",
    "message.transform.bindFailed": "库存绑定失败",
    "message.lzdInboundCreateView.addSkuView.fulfilmentSku": "履行Sku",
    "message.outboundView.table.orderStatus": "订单状态",
    "message.menu.inventory": "库存",
    "message.views.publishTemplateView.addTemplate": "添加模板",
    "message.outboundView.title.fulfilmentOrderCode": "物流单号",
    "message.views.inventoryLedger.orderTypeMap.PURCHASE_IN": "商家入库",
    "message.table.fulfillment.tradeOrderId": "订单号",
    "message.views.inventoryLedger.orderTypeMap.REFOUND_IN": "逆向入库",
    "message.card.fulfillment.shippingProviderName": "配送公司名称",
    "message.TransferOrder.merchant": "调出行业",
    "message.views.inventoryLedger.orderTypeMap.CHECK_IN": "盘盈",
    "message.views.productPublishView.atLeastOneImage": "至少需要1张图片",
    "message.views.inventoryAging.1-30day": "1-30天",
    "message.lzdOutboundViewDetail.title.inLbxOrderCode": "履行单号",
    "message.message.fulfillment.batchShippingMessage": "一次只能选择一个行业的单子进行发货!",
    "message.menu.shipConfirm": "发货确认",
    "message.views.inventoryReconciliation.stockChange": "库存变化",
    "message.card.fulfillment.fulfillmentOrderId": "履约单号",
    "message.outboundView.button.exportBtn": "导出",
    "message.views.productPublishView.upload": "上传",
    "message.views.productPublishView.publishTemplate": "发品模板",
    "message.outboundView.table.supplier": "平台供应商",
    "message.outboundView.button.exportAllOrder": "导出所有",
    "message.TransferOrder.createTime": "创建时间",
    "message.inboundView.table.cancel": "取消",
    "message.CreateTransferOrder.entityCode": "源仓库",
    "message.views.scItemView.status": "状态",
    "message.outboundView.table.receivedQuantity": "收货数量",
    "message.aegInboundDetail.logisticColumns.operateTime": "操作时间",
    "message.transform.failDetail": "请查看失败详情",
    "message.views.workbench.inbound": "入库",
    "message.views.activityInventory.fulfillmentSkuCode": "货品Code",
    "message.taskCenterView.table.taskId": "任务Id",
    "message.views.stockAllocation.fulfillmentSkuCode": "货品Code",
    "message.outboundView.table.detail": "详情",
    "message.inboundView.title.fulfilmentOrderCode": "物流单号",
    "message.outboundView.table.outboundOrder": "出库单据编号",
    "message.lzdOutboundViewDetail.title.sellerInformation": "小二基本信息",
    "message.inboundView.table.receivedQuantity": "收货数量",
    "message.views.activityInventory.occupyQuantity": "占用库存",
    "message.views.liveInventory.warehouse": "仓库",
    "message.views.scItemView.scItemMerchant": "货品市场",
    "message.views.workbench.thisMonth": "本月",
    "message.views.inventoryReconciliation.ledgerDetail": "账目明细",
    "message.views.stockAllocation.platformSkuCode": "商品Code",
    "message.CreateTransferOrder.skuView.search": "搜索",
    "message.views.inventoryAging.skuVolumn": "体积",
    "message.lzdInboundDetail.lzdItemTable.sellerSku": "商家SKU",
    "message.outboundView.title.outboundOrderNo": "单据编号",
    "message.button.search": "搜索",
    "message.menu.ownerTransfer.title": "店铺绑定",
    "message.menu.demoDashboard": "报表样例",
    "message.login.switch_to_th_th": "เปลี่ยนเป็นภาษาไทย",
    "message.card.fulfillment.receiverPhone": "收件人电话",
    "message.views.stockAllocation.fulfillmentSkuName": "货品名称",
    "message.CreateTransferOrder.skuView.add": "添加",
    "message.inboundView.table.inboundOrder": "入库单据编号",
    "message.TransferOrder.outboundWarehouse": "出库仓库",
    "message.views.inventoryAging.121-150day": "121-150 天",
    "message.CreateTransferOrder.destFulfillmentSKU": "目的货品",
    "message.views.dashboardScore.dashboardName.channel_product_sold": "渠道销量",
    "message.aegOutboundOrderDetail.consignColumn.creator": "创建人",
    "message.aegInboundDetail.title.channel": "来源渠道",
    "message.views.activityInventory.scItemId": "货品ID",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_OUT": "调整出库",
    "message.views.scItemView.merchant": "市场",
    "message.aegOutboundOrderDetail.title.storeCode": "仓库编码",
    "message.views.stockAllocation.warehouse": "仓库名称",
    "message.transform.bindFailedAndDownload": "库存绑定失败，下载失败详情",
    "message.aegOutboundOrderDetail.title.skus": "货品明细",
    "message.menu.authorization.auth": "授权",
    "message.card.fulfillment.shippingServiceCode": "配送服务码",
    "message.inboundView.button.exportSelectedOrder": "选择导出",
    "message.transform.mentionInfo": "库存绑定预计需要几分钟。不要关闭当前页面",
    "message.menu.feedback.feedbackName": "反馈",
    "message.inboundView.button.createInboundBtn": "创建",
    "message.views.workbench.productSold": "品销量",
    "message.transform.shopBindingWaitingMention": "店铺绑定预计需要几分钟，请不要关闭当前页面。",
    "message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec": "数量",
    "message.lzdInboundPlanView.queryForm.scItemCode": "货品",
    "message.views.workbench.shopOrderQuantityData": "店铺单量占比",
    "message.views.productPublishView.skuImage": "Sku 图片",
    "message.table.fulfillment.fulfillmentOrderId": "履约单号",
    "message.transform.waitingMention": "库存绑定预计需要几分钟，请不要关闭当前页面。",
    "message.views.productView.platformSkuDetail": "SKU 详情",
    "message.transform.bindCheckSuccess": "库存绑定检查成功",
    "message.outboundView.table.outboundTime": "出库时间",
    "message.views.workbench.operation": "操作",
    "message.menu.authorization.title": "店铺授权",
    "message.views.scItemView.logisticsAttributes": "物流属性",
    "message.views.inventoryLedger.inventoryTypeMap.onWay": "在途",
    "message.views.productView.merchant": "市场",
    "message.views.scItemView.fileExport": "文件导出",
    "message.inboundView.table.expectedTime": "期望上架时间",
    "message.views.scItemView.skuStatus": "SKU 状态",
    "message.views.scItemView.updateScItemButton": "更新提交",
    "message.lzdInboundDetail.lzdItemTable.scItemId": "货品id",
    "message.card.fulfillment.trackingNumber": "运单号",
    "message.views.stockAllocation.outChannel": "调出渠道",
    "message.outboundView.table.creator": "创建人",
    "message.lzdOutboundViewDetail.title.userNick": "店铺名称",
    "message.form.fulfillment.merchantList": "行业",
    "message.lzdInboundCreateView.addSkuView.barcodes": "条形码",
    "message.inboundView.table.createFoc": "创建FOC",
    "message.table.fulfillment.totalItemFee": "总价",
    "message.aegInboundDetail.logisticColumn.operateTime": "操作时间",
    "message.aegInboundDetail.logisticColumns.fulfillStatus": "状态",
    "message.CreateTransferOrder.skuView.crossMerchantSku": "跨行业货品",
    "message.views.scItemView.platformSku": "商品Sku",
    "message.views.dashboardScore.dashboardName.effect_of_operation_activity": "运营活动效果",
    "message.aegInboundDetail.logisticColumn.bizOrderNo": "变更单号",
    "message.menu.gfc.title": "中心仓入驻",
    "message.views.inventoryAging.fulfillmentSkuName": "货品名称",
    "message.table.fulfillment.receiverMobile": "收件人手机",
    "message.views.stockAllocation.ruleAllocation": "调整比例",
    "message.transform.downStep": "下一步",
    "message.views.dashboardScore.dashboardName.proportion_of_shop_product_sold": "店铺销量占比",
    "message.table.fulfillment.sellerId": "卖家编码",
    "message.form.fulfillment.deliveryType": "配送结果确认",
    "message.outboundView.title.warehouseList": "仓库列表",
    "message.views.workbench.all": "全部",
    "message.views.stockAllocation.scItemId": "货品ID",
    "message.aegOutboundOrderDetail.consignColumn.inboundNo": "物流单号",
    "message.CreateTransferOrder.receiverInfo": "收货信息",
    "message.drawer.fulfillment.deliveryFailed": "配送失败",
    "message.login.switch_to_vi_vn": "Chuyển sang tiếng Việt",
    "message.TransferOrder.shipped": "已出库数",
    "message.views.scItemView.skuId": "商品SKU ID",
    "message.views.workbench.orderQuantityTendency": "订单量趋势",
    "message.views.scItemView.shop": "店铺",
    "message.card.fulfillment.orderStatus": "订单状态",
    "message.views.workbench.shopName": "店铺名称",
    "message.views.dashboardScore.dashboardName.to_supplement": "待补货",
    "message.transform.startInventoryBind": "开始库存绑定",
    "message.table.fulfillment.orderItemStatusDesc": "子订单状态",
    "message.lzdInboundCreateView.tableColumn.contactPerson": "联系人姓名",
    "message.transform.cancel": "取消",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherInboundedStock": "其他入库",
    "message.lzdInboundPlanView.replenishColumns.sellerName": "商家名称",
    "message.inboundView.table.expiredTime": "失效时间",
    "message.card.fulfillment.receiverAddress": "收件人地址",
    "message.button.export": "导出",
    "message.transform.record": "最近的绑定记录",
    "message.TransferOrder.variance": "待入库数",
    "message.table.fulfillment.scItemName": "货品名称",
    "message.transform.lzd.description": "Lazada店铺授权入口",
    "message.menu.inventoryAging": "库龄",
    "message.transform.toTransfer": "待转移",
    "message.form.fulfillment.reverseTradeOrderId": "逆向订单号",
    "message.table.fulfillment.receiverName": "收件人姓名",
    "message.transform.shopBindSuccess": "店铺绑定成功",
    "message.views.workbench.noReplenishment": "暂无补货建议",
    "message.views.scItemView.platformTitle": "商品名称",
    "message.aegInboundDetail.purchaseItemColumn.title": "货品名称",
    "message.table.fulfillment.cbFulfillmentOrderId": "跨境履约单号",
    "message.inboundView.alert.prompt": "取消提示",
    "message.views.workbench.toInbound": "待入库",
    "message.views.dashboardScore.dashboardName.all_order_quantity": "总订单量",
    "message.inboundView.title.orderStatus": "订单状态",
    "message.views.stockAllocation.inChannel": "调入渠道",
    "message.outboundView.button.template": "模板",
    "message.CreateTransferOrder.submitBtn": "提交",
    "message.aegOutboundOrderDetail.title.orderStatus": "订单状态",
    "message.table.fulfillment.merchantCode": "行业",
    "message.aegInboundDetail.goodsTable.defectiveQtyDec": "实收残品数量",
    "message.views.workbench.skuNum": "品数量",
    "message.card.fulfillment.tradeCreateTime": "创建时间",
    "message.views.scItemView.basicInfo": "基础信息",
    "message.inboundView.table.supplier": "平台供应商",
    "message.CreateTransferOrder.deliveryInfo": "配送信息",
    "message.menu.inboundPlanItemDetail": "补货计划详情",
    "message.views.scItemView.reload": "重置选择",
    "message.inboundView.button.LzdTemplate": "Lazada模板",
    "message.inboundView.button.AegTemplate": "Aeg模板",
    "message.lzdInboundCreateView.tableColumn.deliverType": "入库类型",
    "message.aegOutboundOrderDetail.title.skuVariety": "商品种类",
    "message.views.workbench.channelItemSold": "渠道销量",
    "message.CreateTransferOrder.deleteBtn": "删除",
    "message.CreateTransferOrder.receiverAddress": "收货地址",
    "message.views.stockAllocation.platformSkuName": "商品名称",
    "message.transform.InventoryBinding": "库存绑定中",
    "message.menu.fulfillmentPackageDetail": "包裹单查看",
    "message.views.liveInventory.sellableOccupy": "可售占用",
    "message.CreateTransferOrder.senderAddress": "发货人地址",
    "message.TransferOrder.outboundOrderNO": "出库单号",
    "message.transform.startCheck": "开始库存绑定检查",
    "message.menu.fulfillmentOrderDetail": "订单详情",
    "message.inboundView.alert.cancel": "取消",
    "message.table.fulfillment.tradePayTime": "订单支付时间",
    "message.views.productView.fulfillmentSku": "货品 SKU",
    "message.inboundView.button.template": "模板",
    "message.views.inventoryAging.61-90day": "61-90 天",
    "message.inboundView.alert.title": "确定要取消该订单？",
    "message.outboundView.title.createTime": "创建时间",
    "message.card.fulfillment.receiverInfomation": "收件人信息",
    "message.card.fulfillment.fulfillmentOrderInformation": "订单信息",
    "message.outboundView.table.outboundReason": "退供原因",
    "message.aegInboundDetail.purchaseItemColumn.scItemId": "货品ID",
    "message.card.fulfillment.tradePayTime": "付款时间",
    "message.inboundView.table.merchantName": "商家名称",
    "message.card.fulfillment.receiverZip": "收件人邮编",
    "message.transform.bindException": "库存绑定异常",
    "message.views.scItemView.operation": "操作",
    "message.views.stockAllocation.save": "保存 ",
    "message.aegOutboundOrderDetail.purchaseItemColumn.title": "货品名称",
    "message.table.fulfillment.tradeOrderItemId": "子订单号",
    "message.table.fulfillment.warehouseName": "仓名称",
    "message.views.workbench.productSoldTendency": "销量趋势",
    "message.views.inventoryAging.inventoryType": "库存类型",
    "message.outboundView.table.operate": "操作",
    "message.views.productView.price": "价格",
    "message.TransferOrder.detail": "详情",
    "message.inboundView.button.reset": "重置",
    "message.menu.dashboard": "报表",
    "message.table.fulfillment.itemId": "商品id",
    "message.inboundView.alert.selectFile": "文件选择",
    "message.views.productPublishView.batchPublish": "批量发品",
    "message.aegOutboundOrderDetail.logisticColumns.operator": "变更人",
    "message.table.fulfillment.sellerSku": "Seller Sku",
    "message.login.switch_to_in_id": "Beralih ke bahasa Indonesia",
    "message.lzdInboundPlanView.queryForm.warehouse": "仓库",
    "message.views.workbench.dashboardDescription.inventoryTurnOver": "库存周转率： 最近一个月的销量/平均库存",
    "message.views.stockAllocation.adjustStockSuccess": "调整库存成功",
    "message.lzdInboundCreateView.addSkuView.searchBtn": "搜索",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_IN": "调拨入库",
    "message.aegInboundDetail.title.actualArrivalTime": "实际上架时间",
    "message.lzdInboundCreateView.addSkuView.shelfLife": "保质期",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_OUT": "调拨出库",
    "message.views.productView.itemId": "商品 ID",
    "message.views.stockAllocation.edit": "编辑",
    "message.views.inventoryLedger.inventoryTypeMap.good": "良品",
    "message.lzdInboundDetail.title.ioType": "入库类型",
    "message.outboundView.table.createTime": "创建时间",
    "message.views.stockAllocation.channelName": "渠道名称",
    "message.menu.inOutBound": "出入库",
    "message.aegOutboundOrderDetail.title.createTime": "创建时间",
    "message.transform.unfinished": "未完成",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_IN": "库存调整入库",
    "message.aegInboundDetail.title.batchInformation": "批次信息",
    "message.aegInboundDetail.title.expectedTime": "期望上架时间",
    "message.transform.boundShop": "绑定店铺",
    "message.transform.orderCheck": "ICP/IO订单检查",
    "message.transform.shopBindException": "店铺绑定异常",
    "message.views.scItemView.itemId": "商品 ID",
    "message.transform.recentBindInventoryRecord": "最近库存绑定结果",
    "message.form.fulfillment.tradeCreateTime": "创建时间",
    "message.views.inventoryAging.31-60day": "31-60 天",
    "message.lzdInboundCreateView.addSkuView.scItemName": "货品名称",
    "message.views.workbench.dailyItemSold": "日销量",
    "message.common.select": "请选择",
    "message.lzdInboundCreateView.addSkuView.addSkuTitle": "添加Sku",
    "message.views.publishTemplateView.gmtCreate": "创建时间",
    "message.outboundView.button.LzdTemplate": "Lazada模板",
    "message.form.fulfillment.shippingTypeDesc": "配送类型",
    "message.menu.productView": "商品",
    "message.views.stockAllocation.allMoreThan100": "总比例不允许大于100,请调整",
    "message.table.fulfillment.warehouseCode": "仓编码",
    "message.views.inventoryReconciliation.endDateStock": "结果库存",
    "message.lzdInboundCreateView.title.skuFlag": "SKUS",
    "message.views.dashboardScore.table.rate": "评分",
    "message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku": "履行Sku",
    "message.views.publishTemplateView.deleteTemplate": "删除模板",
    "message.views.publishTemplateView.operator": "操作人",
    "message.views.workbench.orderQuantity": "订单量",
    "message.common.input": "请输入",
    "message.aegInboundDetail.logisticColumn.fulfillStatusDesc": "变更描述",
    "message.taskCenterView.table.gmtCreated": "发起时间",
    "message.table.fulfillment.itemShippingActualPaidFee": "实际运费",
    "message.TransferOrder.search": "搜索",
    "message.views.liveInventory.unSellableOccupy": "不可售占用",
    "message.aegOutboundOrderDetail.title.totalQtyDec": "商品数量",
    "message.CreateTransferOrder.skuView.barcode": "编码",
    "message.views.publishTemplateView.longDesc": "长描述",
    "message.button.reset": "重置",
    "message.views.inventoryReconciliation.changeTypeMap.totalShipped": "销售出库",
    "message.views.scItemView.fulfillmentTitle": "货品名称",
    "message.aegOutboundOrderDetail.title.returnOrderNO": "退供单号",
    "message.table.fulfillment.receiverPhone": "收件人电话",
    "message.CreateTransferOrder.skuView.quantity": "调拨数量",
    "message.views.stockAllocation.stockAllocation": "调整库存",
    "message.outboundView.button.reset": "重置",
    "message.lzdInboundCreateView.tableColumn.warehouse": "仓库",
    "message.views.inventoryAging.platform": "平台",
    "message.table.fulfillment.cod": "到付",
    "message.menu.fulfillmentOrder": "订单",
    "message.views.dashboardScore.table.comment": "评价",
    "message.table.fulfillment.shippingTypeDesc": "配送类型",
    "message.button.helpCenter": "帮助中心",
    "message.card.fulfillment.promiseLatestDate": "承诺最晚日期",
    "message.table.fulfillment.shippingType": "配送类型码",
    "message.views.productView.status": "状态",
    "message.lzdInboundCreateView.addSkuView.resetBtn": "重置",
    "message.transform.bind": "绑定",
    "message.outboundView.table.skuQuantity": "sku数量",
    "message.views.inventoryReconciliation.startDateStock": "起始库存",
    "message.table.fulfillment.itemName": "商品名称",
    "message.button.submit": "提交",
    "message.button.setting": "设置",
    "message.views.stockAllocation.allLessThan100": "总比例不允许小于100,请调整",
    "message.transform.downloadErrorFileUrl": "错误文件下载链接",
    "message.CreateTransferOrder.skuView.cancel": "取消",
    "message.common.search": "查询",
    "message.table.fulfillment.receiverProvince": "收件人省",
    "message.TransferOrder.shopName": "店铺名称",
    "message.taskCenterView.table.errorMsg": "异常信息",
    "message.views.workbench.gmv": "销售额",
    "message.CreateTransferOrder.receiverName": "收货人",
    "message.aegOutboundOrderDetail.title.storeName": "仓库名称",
    "message.aegInboundDetail.title.cancelPerson": "取消人",
    "message.transform.startBind": "开始绑定",
    "message.transform.authStore": "授权店铺",
    "message.inboundView.table.operate": "操作",
    "message.aegInboundDetail.title.basicInformation": "基本信息",
    "message.menu.feedback.feedback": "意见反馈",
    "message.taskCenterView.button.reset": "重置",
    "message.menu.fulfillmentPackage": "包裹单查看",
    "message.lzdOutboundViewDetail.title.outboundOrderCode": "出库单号",
    "message.menu.inventoryLedger": "库存流水",
    "message.TransferOrder.create": "创建",
    "message.outboundView.button.search": "查询",
    "message.views.scItemView.productType": "产品类型",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatus": "变更状态",
    "message.TransferOrder.pleaseInput": "请输入",
    "message.views.scItemView.bindRelatedPlatformSku": "商品绑定",
    "message.inboundView.table.platform": "行业",
    "message.views.publishTemplateView.gmtModified": "修改时间",
    "message.CreateTransferOrder.receiverTel": "收货电话",
    "message.CreateTransferOrder.skuView.sellerSku": "Seller SKU",
    "message.views.workbench.gmvRank": "销售额排行",
    "message.views.workbench.mom": "环比",
    "message.CreateTransferOrder.destEntityCode": "目的仓库",
    "message.TransferOrder.pleaseSelect": "请选择",
    "message.menu.item": "商/货品",
    "message.CreateTransferOrder.skuView.SKU": "品",
    "message.aegOutboundOrderDetail.consignColumn.operate": "操作",
    "message.transform.inventoryBind": "库存绑定",
    "message.lzdInboundDetail.lzdItemTable.itemCompleted": "正常品数量",
    "message.drawer.fulfillment.ship": "发货",
    "message.aegInboundDetail.title.remart": "备注",
    "message.views.scItemView.sureBind": "确认绑定?",
    "message.card.fulfillment.warehouseCode": "仓编码",
    "message.outboundView.table.merchantName": "商家名称",
    "message.table.fulfillment.scItemId": "货品id",
    "message.taskCenterView.table.taskName": "任务名称",
    "message.transform.bindCheckException": "库存绑定检查异常",
    "message.views.scItemView.showRelation": "绑定记录",
    "message.inboundView.table.planQuantity": "计划数量",
    "message.views.productView.mainShop": "店铺",
    "message.lzdOutboundViewDetail.title.logisticLogs": "物流执行日志",
    "message.aegInboundDetail.logisticColumns.fulfillStatusDesc": "状态描述",
    "message.views.productPublishView.mainImage": "商品主图",
    "message.lzdOutboundViewDetail.title.ioTypeName": "单据类型",
    "message.views.activityInventory.activeTime": "起始时间",
    "message.views.workbench.quantity": "数量",
    "message.views.feedback.feedbackOptions.productSuggestion": "产品建议",
    "message.lzdInboundPlanView.replenishColumns.replOrderNo": "补货单号",
    "message.views.publishTemplateView.templateName": "模板名称",
    "message.views.dashboardScore.table.dashboardName": "报表名称",
    "message.inboundView.button.search": "查询",
    "message.TransferOrder.inventoryType": "库存类型",
    "message.login.switch_to_another_language": "switch to English",
    "message.outboundView.table.planQuantity": "计划数量",
    "message.menu.inboundItemName": "入库",
    "message.inboundView.alert.shop": "店铺选择",
    "message.aegInboundDetail.title.createTime": "创建时间",
    "message.views.productView.showRelation": "绑定记录",
    "message.select.fulfillment.partialShipping": "部分发货",
    "message.views.dashboardScore.table.operation": "操作",
    "message.views.productView.sellerSku": "Seller SKU",
    "message.views.activityInventory.platformSkuCode": "商品Code",
    "message.views.liveInventory.shopName": "店铺名称",
    "message.card.fulfillment.receiverCity": "收件人市",
    "message.menu.transferOrder": "调拨功能",
    "message.lzdInboundDetail.title.estimateTime": "预计到达时间",
    "message.views.publishTemplateView.merchant": "市场",
    "message.inboundView.table.warehouse": "仓库",
    "message.lzdOutboundViewDetail.title.SKU": "SKU",
    "message.table.fulfillment.reverseTradeOrderId": "逆向订单号",
    "message.drawer.fulfillment.shippingType": "发货类型",
    "message.views.productView.barcode": "货品条码",
    "message.lzdInboundDetail.title.mobile": "联系方式",
    "message.button.print": "打印",
    "message.views.productPublishView.import": "导入",
    "message.CreateTransferOrder.skuView.inventoryType": "库存类型",
    "message.form.fulfillment.tradeOrderId": "订单号",
    "message.aegOutboundOrderDetail.purchaseItemColumn.scItemId": "货品Id",
    "message.aegInboundDetail.title.skus": "货品明细",
    "message.menu.gfc.enter": "中心仓入驻",
    "message.aegInboundDetail.title.logisticLogs": "物流执行日志",
    "message.inboundView.title.createTime": "创建时间",
    "message.views.publishTemplateView.operation": "操作",
    "message.taskCenterView.button.search": "查询",
    "message.aegInboundDetail.purchaseItemColumn.measureUnit": "库存单位",
    "message.table.fulfillment.action": "操作",
    "message.table.fulfillment.itemDiscountFee": "折扣价格",
    "message.CreateTransferOrder.skuView.fulfillmentSku": "Fulfillment SKU",
    "message.CreateTransferOrder.basicInfo": "基本信息",
    "message.views.workbench.thisWeek": "本周",
    "message.views.inventoryAging.averageAge": "平均库龄",
    "message.views.workbench.fulfillmentOrderId": "单号",
    "message.aegOutboundOrderDetail.logisticColumns.operateTime": "操作时间",
    "message.login.user_profile": "用户信息",
    "message.views.stockAllocation.search": "搜索",
    "message.aegOutboundOrderDetail.title.logisticOrderCode": "物流单号",
    "message.views.liveInventory.platform": "平台",
    "message.common.fulfillment.deliveryConfirm": "配送确认",
    "message.CreateTransferOrder.skus": "货品信息",
    "message.table.fulfillment.orderStatusDesc": "订单状态",
    "message.aegInboundDetail.goodsTable.barcode": "条形码",
    "message.lzdInboundDetail.title.shop": "店铺名称",
    "message.transform.authList": "授权列表",
    "message.transform.operateStore": "操作店铺",
    "message.views.inventoryLedger.inventoryTypeMap.defective": "残品",
    "message.views.workbench.toReplenishment": "待补货",
    "message.aegInboundDetail.title.creator": "创建人",
    "message.taskCenterView.title.source": "任务来源",
    "message.views.activityInventory.channelCode": "活动Code",
    "message.transform.selectShop": "选择店铺",
    "message.aegInboundDetail.goodsTable.scItemId": "货品Id",
    "message.aegOutboundOrderDetail.consignColumn.reserveOrderNo": "预约单号",
    "message.aegInboundDetail.purchaseItemColumn.receivedDefectiveQtyDec": "实收残品数量",
    "message.views.workbench.orderTime": "下单时间",
    "message.lzdOutboundViewDetail.title.orderStatus": "订单状态",
    "message.aegOutboundOrderDetail.consignColumn.gmtCreateStr": "创建时间",
    "message.menu.inventoryReconciliation": "库存对账",
    "message.table.fulfillment.orderType": "单据类型",
    "message.table.fulfillment.buyerName": "买家名称",
    "message.outboundView.table.orderQuantity": "下单数量",
    "message.CreateTransferOrder.deliverType": "配送方式",
    "message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec": "实退数量",
    "message.CreateTransferOrder.skuView.stock": "库存",
    "message.form.fulfillment.inputShippingName": "请输入快递公司！",
    "message.table.fulfillment.unitPrice": "单价",
    "message.views.inventoryLedger.inventoryTypeMap.transferOnWay": "调拨在途",
    "message.views.liveInventory.seller": "卖家",
    "message.card.fulfillment.deliveryInfomation": "配送信息",
    "message.table.fulfillment.quantity": "数量",
    "message.views.stockAllocation.sellableStock": "可售库存",
    "message.lzdInboundCreateView.tableColumn.submitBtn": "提交",
    "message.table.fulfillment.itemQuantity": "商品数量",
    "message.lzdOutboundViewDetail.title.deliverTypeName": "配送类型",
    "message.transform.startShopBind": "开始店铺绑定",
    "message.views.productView.platformSku": "商品SKU",
    "message.views.inventoryReconciliation.dateRange": "时间区间",
    "message.views.workbench.wow": "周同比",
    "message.aegOutboundOrderDetail.title.creator": "创建人",
    "message.form.fulfillment.siteList": "站点",
    "message.inboundView.button.exportAllOrder": "导出所有",
    "message.views.scItemView.itemCode": "货品Sku",
    "message.lzdOutboundViewDetail.title.sellerAddress": "小二地址",
    "message.common.reset": "重置",
    "message.lzdInboundCreateView.addSkuView.quantity": "数量",
    "message.CreateTransferOrder.estimatedInboundTime": "预计入库时间",
    "message.modal.pdfTitle": "生成pdf成功",
    "message.outboundView.table.cancel": "取消",
    "message.aegOutboundOrderDetail.title.supplierId": "供应商编码",
    "message.views.inventoryLedger.orderCode": "订单编号",
    "message.views.dashboardScore.dashboardName.to_deliver": "待发货",
    "message.views.inventoryAging.150-180day": "150-180 天",
    "message.table.fulfillment.receiverCountry": "收件人国家",
    "message.aegOutboundOrderDetail.title.batchInformation": "批次信息",
    "message.card.fulfillment.itemInfomation": "商货品信息",
    "message.views.scItemView.length": "长度",
    "message.aegOutboundOrderDetail.title.outboundTime": "出库时间",
    "message.views.scItemView.brand": "品牌",
    "message.menu.outboundItem": "出库",
    "message.CreateTransferOrder.senderInfo": "发货人信息",
    "message.aegInboundDetail.logisticColumn.operator": "变更人",
    "message.message.fulfillment.deliveryConfirm": "到货结果已确认!",
    "message.inboundView.title.inboundOrder": "单据编号",
    "message.views.inventoryLedger.changeQuantity": "变更数量",
    "message.CreateTransferOrder.receiverPostCode": "收货邮编",
    "message.card.fulfillment.receiverCountry": "收件人国家",
    "message.aegInboundDetail.title.orderStatus": "订单状态",
    "message.views.workbench.fulfillmentOrderItemId": "子单号",
    "message.common.detail": "查看详情",
    "message.transform.secondStep": "第二步",
    "message.inboundView.table.creator": "创建人",
    "message.form.fulfillment.orderStatus": "订单状态",
    "message.outboundView.table.inventoryType": "库存类型",
    "message.views.workbench.suggestToReplenish": "建议补货",
    "message.views.workbench.shopItemSoldData": "店铺销量占比",
    "message.lzdOutboundViewDetail.title.address": "入仓地址",
    "message.table.fulfillment.orderItemStatusReason": "子单状态原因",
    "message.form.fulfillment.inputTrackingNumber": "请输入运单号！",
    "message.card.fulfillment.buyerId": "买家id",
    "message.transform.bindCheckFailed": "库存绑定检查失败",
    "message.views.inventoryLedger.orderTypeMap.CHECK_OUT": "盘亏",
    "message.aegOutboundOrderDetail.title.basicInformation": "基本信息",
    "message.lzdInboundCreateView.title.basicFlag": "基本信息",
    "message.lzdInboundCreateView.tableColumn.inboundType": "配送类型",
    "message.table.fulfillment.trackingNumbers": "运单号",
    "message.CreateTransferOrder.receiverCountry": "收货国家",
    "message.views.publishTemplateView.templateDetail": "模板详情",
    "message.login.task_center": "任务中心",
    "message.aegOutboundOrderDetail.purchaseItemColumn.brandName": "品牌",
    "message.inboundView.title.shopName": "店铺",
    "message.views.inventoryLedger.orderTypeMap.OTHER_INBOUND": "其他入库",
    "message.card.fulfillment.tradeOrderId": "订单号",
    "message.views.workbench.cargo": "货品",
    "message.transform.transferred": "已转移"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/zh-cn.js
// module id = 32Kc
// module chunks = 16